export type CvUploadStatus = "Pending" | "Processing" | "Completed" | "Failed"

/** Maps the numeric status code sent by the backend to a display string. */
export function cvStatusFromCode(code: number): CvUploadStatus {
  switch (code) {
    case 0:
      return "Pending"
    case 1:
      return "Processing"
    case 2:
      return "Completed"
    case 3:
      return "Failed"
    default:
      return "Failed"
  }
}

export interface AcceptedCvUploadDto {
  correlationId: string
  status: CvUploadStatus
}

/** Shape of the SignalR "CvProcessed" event emitted by the backend. */
export interface CvProcessedDto {
  correlationId: string
  status: number // 0=Pending 1=Processing 2=Completed 3=Failed
  candidateId: string | null
  applicationId: string | null
  errorMessage: string | null
  errorCode: string | null
}

export interface PendingCvUpload {
  correlationId: string
  fileName: string
  status: CvUploadStatus
  /** HTTP upload progress 0-100. Set to 100 after the 202 is received. */
  progress?: number
  candidateId?: string
  applicationId?: string
  errorMessage?: string
}
